import React from "react";
import { useNavigate } from "react-router-dom";
import "./FloatingPromo.css";

const FloatingPromo = () => {
    const navigate = useNavigate();

    return (
        <>
            <div className="floating-flash-wrapper">
                <div className="floating-flash">
                    <img
                        src="/assets/images/banners/flying_bird.gif"
                        alt="Flash Deals"
                        onClick={() => navigate("/Spare-Parts/SpecialOffers")}
                    />
                </div>
            </div>
        </>
    );
};

export default FloatingPromo;